// extracted by mini-css-extract-plugin
module.exports = {"genericInputDefaults":"styles_genericInputDefaults__2jMC-"};